import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "website-selector" };
import { computed } from "vue";
import OneDeskAutocompleteDrowpdown from "@/components/atoms/OneDeskAutocompleteDrowpdown.vue";
import { ReferenceValuesTypes } from "@/store/modules/reference-values/types";
import { useStore } from "vuex";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WebsiteSelector',
    props: {
        modelValue: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const store = useStore();
        const websiteList = computed(() => store.getters[ReferenceValuesTypes.WEBSITE]);
        const selected = computed({
            get: () => props.modelValue,
            set: (value) => emit("update:modelValue", value),
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(OneDeskAutocompleteDrowpdown, {
                    modelValue: selected.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selected).value = $event)),
                    options: websiteList.value,
                    "linera-label": false,
                    "option-label": "label",
                    "option-value": "id",
                    "force-selection": "",
                    placeholder: "Enter an URL"
                }, null, 8, ["modelValue", "options"])
            ]));
        };
    }
});
